import { ITenantParameter } from "./interface";

const FIVE = -5;
const TWO = -2;

export function getTenantParameters(locationInformation: string | null): ITenantParameter | null {
	if (locationInformation) {
		const input = locationInformation.toString();
		const tenantId = input.slice(0, FIVE);
		const storeBranch = input.slice(FIVE);
		const store = storeBranch.slice(0, TWO);
		const branch = storeBranch.slice(TWO);
		return {
			input,
			storeBranch,
			store,
			branch,
			tenantId,
			tenant: `${tenantId}00000`,
		};
	}
	return null;
}
